module.exports = __webpack_public_path__ + "media/images/logos/rotpunkt-logo-bae56749ecfc711155afe47feff12668.jpg";